<mat-toolbar class="toolbarNav">
  <div class="button-box">
    <div class="title-captain">CAPTAIN PUB</div>
    <div class="container-pictos">
      <button mat-fab class="serveur-icon">
        <span class="count count-call">{{
          actions.appel ? actions.appel : 0
        }}</span>
        <mat-icon svgIcon="appel-serveur"></mat-icon>
        <div class="desc">Appels</div>
      </button>
      <button mat-fab class="serveur-icon">
        <span class="count count-call-water">{{
          actions.eau ? actions.eau : 0
        }}</span>
        <mat-icon svgIcon="eau"></mat-icon>
        <div class="desc">Eau</div>
      </button>
      <button mat-fab class="serveur-icon">
        <span class="count count-call-bread">{{
          actions.pain ? actions.pain : 0
        }}</span>
        <mat-icon svgIcon="pain"></mat-icon>
        <div class="desc">Pain</div>
      </button>
      <button mat-fab class="serveur-icon">
        <span class="count count-call-salt">{{
          actions.selPoivre ? actions.selPoivre : 0
        }}</span>
        <mat-icon svgIcon="sel-poivre"></mat-icon>
        <div class="desc">Sel/Poivre</div>
      </button>
      <button mat-fab class="serveur-icon">
        <span class="count count-call-paiement">{{
          actions.payer ? actions.payer : 0
        }}</span>
        <mat-icon svgIcon="paiement"></mat-icon>
        <div class="desc">Paiement</div>
      </button>
    </div>
  </div>
</mat-toolbar>

<mat-table #table [dataSource]="dataSource" matSort class="mat-elevation-z8">
  <!-- Position Column -->
  <ng-container matColumnDef="id">
    <mat-header-cell *matHeaderCellDef mat-sort-header class="number-header"
      >No. de table
    </mat-header-cell>

    <mat-cell *matCellDef="let table" style="padding-left:8px;width:25%">
      Table {{ table.num }}</mat-cell
    >
  </ng-container>

  <ng-container matColumnDef="time">
    <mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      style="color: #000; padding-left:8px;"
    >
      <mat-icon svgIcon="av_timer"></mat-icon>
    </mat-header-cell>
    <mat-cell
      *matCellDef="let table; let i = index"
      [ngStyle]="{ color: table.color }"
    >
      <ng-container *ngIf="table.time != null">
        {{ table.fromNow }}
      </ng-container>
    </mat-cell>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="action">
    <mat-header-cell *matHeaderCellDef mat-sort-header class="action-header">
      Action
    </mat-header-cell>
    <mat-cell
      *matCellDef="let table; let i = index"
      style="justify-content: flex-end;flex-grow:1;"
    >
      <mat-icon
        *ngIf="table.action == 'Appel Serveur'"
        class="material-icons color_blue"
        >room_service</mat-icon
      >
      <ng-container *ngFor="let action of table.actions">
        <button
          class="salt-button"
          *ngIf="action.name === 'selPoivre'"
          mat-flat-button
          color="primary"
          (click)="deleteAction(action.id, action.name)"
        >
          Sel/Poivre
        </button>
        <button
          class="bread-button"
          *ngIf="action.name === 'pain'"
          mat-flat-button
          color="primary"
          (click)="deleteAction(action.id, action.name)"
        >
          Pain
        </button>
        <button
          class="pay-button"
          *ngIf="action.name === 'payer'"
          mat-flat-button
          color="primary"
          (click)="deleteAction(action.id, action.name)"
        >
          Paiement
        </button>
        <button
          class="water-button"
          *ngIf="action.name === 'eau'"
          mat-flat-button
          color="primary"
          (click)="deleteAction(action.id, action.name)"
        >
          Eau
        </button>
        <button
          *ngIf="action.name === 'appel'"
          mat-flat-button
          color="primary"
          (click)="deleteAction(action.id, action.name)"
        >
          Appel
        </button>
      </ng-container>

      <button
        class="delete-all"
        mat-flat-button
        color="warn"
        (click)="deleteTable(table.num)"
      >
        Supprimer
      </button>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>

<p *ngIf="tableCount == 0">
  Il n'y a pas de table à servir pour l'instant.
</p>
